import { zOption } from "src/types/ZOption";
import { z } from "zod";

export const zDemoData = z.object({
  id: z.number(),
  name: z.string(),
  count: z.number(),
  country: zOption,
  beginDate: z.string(),
});

export type ZDemoData = z.infer<typeof zDemoData>;

export interface DemoFilters {
  name?: string;
  countryCodes?: string[];
  minCount?: number;
  maxCount?: number;
}
